import {Col, ProgressBar, Row} from "react-bootstrap";
import React from "react";

export default function ProgressChart(props) {
    return (
        <Row>
            <Col md={12}>
                <Row>
                    <Col md={9}>
                        <p className={'card-sub-title'}>{props.title} ({props.value.toLocaleString()})</p>
                    </Col>
                    <Col md={3}>
                        <p className={'card-sub-title progress-percentage'}>{props.precentage}%</p>
                    </Col>
                </Row>
                <Row className={'progress-bar-element'}>
                    <Col md={12}>
                        <ProgressBar variant={props.variant} now={props.precentage} />
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}